import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04281628"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-xl" }
const _hoisted_2 = { class: "notice" }
const _hoisted_3 = ["onSubmit"]
const _hoisted_4 = { class: "buttons" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "footer-return" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_MHForm = _resolveComponent("MHForm")!
  const _component_SecurityMessage = _resolveComponent("SecurityMessage")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, { size: "xs" }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('heading')), 1),
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.userMFAType === 'AUTHENTICATOR' ? _ctx.$t('authenticatorNoticeCopy') : _ctx.$t('emailNoticeCopy')), 1),
      _createVNode(_component_MHForm, {
        class: "mfa-verify-form",
        ref: "form"
      }, {
        default: _withCtx(({ handleSubmit, meta }) => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.submitMfaCode)), ["prevent"])
          }, [
            _createVNode(_component_BaseInputText, {
              ref: "verificationCodeInput",
              inputName: "verificationCode",
              "data-cy": "verification-input",
              validationRules: "required|validVerificationCode",
              labelLocation: "top",
              labelText: _ctx.$t('verificationForm.verificationCodeField.label'),
              placeholder: _ctx.$t('verificationForm.verificationCodeField.placeholder'),
              autoFocusInput: true,
              inputModel: _ctx.verificationCode,
              "onUpdate:inputModel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.verificationCode = $event))
            }, null, 8, ["labelText", "placeholder", "inputModel"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_BaseButton, {
                class: "btn btn-verify-submit btn-ghost",
                "data-cy": "mfa-verify-button",
                disabled: !meta.valid
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('verificationForm.submitBtn')), 1)
                ]),
                _: 2
              }, 1032, ["disabled"]),
              (_ctx.userMFAType === 'EMAIL')
                ? (_openBlock(), _createBlock(_component_BaseButton, {
                    key: 0,
                    class: "btn-resend-code btn-ghost",
                    "data-cy": "resend-email-button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sendEmailCode()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('verificationForm.sendCodeBtn')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ], 40, _hoisted_3)
        ]),
        _: 1
      }, 512),
      _createVNode(_component_SecurityMessage),
      _hoisted_5,
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("a", {
          href: `${_ctx.urlBaseApp}/`
        }, _toDisplayString(_ctx.$t('returnToApp')), 9, _hoisted_7)
      ])
    ]),
    _: 1
  }))
}